"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverRealTimeDataOutput = exports.StatusData = exports.PositionData = exports.Point = exports.SocketData = exports.MobileData = exports.VehicleData = exports.StatsData = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class StatsData {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], StatsData.prototype, "lastTripDoneAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], StatsData.prototype, "nbTripDoneSecondLastMonth", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], StatsData.prototype, "nbTripDoneLastMonth", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], StatsData.prototype, "nbTripDone", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], StatsData.prototype, "activityStatus", void 0);
exports.StatsData = StatsData;
class VehicleData {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleData.prototype, "vehicleKey", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], VehicleData.prototype, "updatedAt", void 0);
exports.VehicleData = VehicleData;
class MobileData {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], MobileData.prototype, "pushToken", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], MobileData.prototype, "mobilePlatform", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], MobileData.prototype, "appVersion", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(['fr', 'en']),
    __metadata("design:type", String)
], MobileData.prototype, "locale", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], MobileData.prototype, "updatedAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], MobileData.prototype, "mobileYear", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], MobileData.prototype, "nfcAvailable", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], MobileData.prototype, "mobileModelName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], MobileData.prototype, "mobileBrand", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], MobileData.prototype, "mobileOS", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], MobileData.prototype, "mobileScreenDensity", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], MobileData.prototype, "mobileResolution", void 0);
exports.MobileData = MobileData;
class SocketData {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(['CONNECTED', 'DISCONNECTED']),
    __metadata("design:type", String)
], SocketData.prototype, "socketStatus", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], SocketData.prototype, "updatedAt", void 0);
exports.SocketData = SocketData;
class Point {
}
__decorate([
    (0, class_validator_1.IsLatitude)(),
    __metadata("design:type", Number)
], Point.prototype, "lat", void 0);
__decorate([
    (0, class_validator_1.IsLongitude)(),
    __metadata("design:type", Number)
], Point.prototype, "lng", void 0);
exports.Point = Point;
class PositionData {
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => Point),
    __metadata("design:type", Point)
], PositionData.prototype, "point", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PositionData.prototype, "accuracy", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], PositionData.prototype, "speed", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], PositionData.prototype, "bearing", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PositionData.prototype, "updatedAt", void 0);
exports.PositionData = PositionData;
class StatusData {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(['SUBSCRIPTION', 'SUBSCRIPTION_REVIEW', 'SUSPENDED', 'ACTIVATED', 'DEACTIVATED']),
    __metadata("design:type", String)
], StatusData.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], StatusData.prototype, "updatedAt", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], StatusData.prototype, "suspendedUntil", void 0);
exports.StatusData = StatusData;
class DriverRealTimeDataOutput {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverRealTimeDataOutput.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => MobileData),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", MobileData)
], DriverRealTimeDataOutput.prototype, "mobileData", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => SocketData),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", SocketData)
], DriverRealTimeDataOutput.prototype, "socketData", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => StatsData),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", StatsData)
], DriverRealTimeDataOutput.prototype, "statsData", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PositionData),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", PositionData)
], DriverRealTimeDataOutput.prototype, "positionData", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => VehicleData),
    __metadata("design:type", VehicleData)
], DriverRealTimeDataOutput.prototype, "vehicleData", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => StatusData),
    __metadata("design:type", StatusData)
], DriverRealTimeDataOutput.prototype, "statusData", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverRealTimeDataOutput.prototype, "updatedAt", void 0);
exports.DriverRealTimeDataOutput = DriverRealTimeDataOutput;
